const errors = {
  heading: "Erreur inconnue",
  message: "L'application a rencontré une erreur inconnue.",
};

export default errors;
